<mat-sidenav #appDrawer mode="side" opened="true" *ngIf="isUserLoggedIn$">
<!--<mat-sidenav #appDrawer mode="side" opened="true">-->
  <mat-nav-list>
    <app-menu-list-item *ngFor="let item of menuItems" [item]="item"></app-menu-list-item>
  </mat-nav-list>
</mat-sidenav>
